
export const appConfig = {
  devMode: !!process.env.REACT_APP_DEV_MODE
}
